import * as _ from "lodash";
import * as angular from "angular";
import { Team } from "../../../models/team.model";
import { DialogUtils } from "../../../helper/dialog.helper";

let TeamAutocompleteComponent = {
    selector: "vcTeamAutocomplete",
    templateUrl:
        "/angular/components/team/autocomplete/team-autocomplete.component.html",
    bindings: {
        selectedTeam: "=?",
        selectedTeams: "=?",
        teamId: "=?",
        isRequired: "=?",
        inForm: "=?",
        label: "=?",
        noLabel: "=?",
        noCreate: "=?",
        hideUsers: "=?",
    },
    controller: class TeamAutocompleteController {
        // * bindings for typescript compiler *
        public selectedTeam?: any;
        public selectedTeams?: any;
        public teamId?: number | string;
        public isRequired?: any;
        public inForm?: any;
        public label?: any;
        public noLabel?: any;
        public noCreate?: any;
        public hideUsers?: any;
        // ************************************

        public false = true;
        public teamSearch = "";
        public searchPromise: any;
        public previousSearch: any;
        public teams: Team[] = [];

        private readonly $scope: any;
        private $http: any;
        private $q: any;
        private readonly modelsUtils: any;
        private readonly dialog: DialogUtils;

        constructor(
            $scope: any,
            $http: any,
            $q: any,
            ModelsUtils: any,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.$http = $http;
            this.$q = $q;
            this.modelsUtils = ModelsUtils;
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.inForm = this.inForm ? this.inForm : false;
            this.noCreate = this.noCreate ? this.noCreate : false;
            this.isRequired = this.isRequired ? this.isRequired : false;
            this.hideUsers = angular.isUndefined(this.hideUsers)
                ? false
                : this.hideUsers;
            this.noLabel = this.noLabel;
            this.label = this.label ? this.label : "Team";
            this.selectedTeams = this.selectedTeams ? this.selectedTeams : null;

            if (this.selectedTeam) {
                this.teamSearch = this.selectedTeam.tname;
            }

            if (this.selectedTeams) {
                this.$scope.$watch(
                    () => this.selectedTeams,
                    (newValue, oldValue) => {
                        if (oldValue && newValue !== oldValue) {
                            this.filterItems(this.teamSearch, true);
                        }
                    },
                    true
                );
            }
        }

        filterItems(query: any, refresh: boolean): Promise<Team[]> {
            if (query === this.previousSearch && !refresh) {
                return this.$q.resolve(this.teams);
            }
            this.previousSearch = query;

            if (this.searchPromise)
                this.searchPromise.resolve("user cancelled");
            this.searchPromise = this.$q.defer();

            const deferred = this.$q.defer();
            let filters = {
                search: query,
                needsCount: false,
                limit: 10,
                selectedTeams: this.selectedTeams
                    ? this.selectedTeams.map((team: Team) => team.tid)
                    : [],
            };

            this.$http({
                url: "/v2/team/all",
                method: "GET",
                params: {
                    filters: filters,
                },
                timeout: this.searchPromise.promise,
            }).then((response: any) => {
                if (!response || !response.data || !response.data.data)
                    deferred.reject();
                this.teams = [];
                for (let i = 0; i < response.data.data.length; i++) {
                    this.teams.push(
                        this.modelsUtils.team(response.data.data[i])
                    );
                }
                deferred.resolve(this.teams);
            });

            return deferred.promise;
        }

        teamChanged(team: Team): void {
            if (team && team.tid) {
                this.selectedTeam = _.cloneDeep(team);
                this.teamId = team.tid;
                if (this.selectedTeams) {
                    this.selectedTeams.push(team);
                    this.removeTeamFromList(team.tid);
                    this.teamSearch = "";
                }
            }
        }

        removeTeamFromList(tid: string | number): void {
            angular.forEach(this.teams, (team: Team, $index: number) => {
                if (team.tid === tid) {
                    this.teams.splice($index, 1);
                }
            });
        }

        checkEmpty(team: string): void {
            if (team === "") {
                setTimeout(() => {
                    this.selectedTeam = null;
                }, 100);
            }
        }

        showTeamError(): boolean {
            return (
                this.inForm &&
                this.teamSearch &&
                this.teamSearch != "" &&
                !this.selectedTeam
            );
        }

        openTeamModal(team: Team, ev: any): void {
            //hack to stop the autocomplete matches covering the create list dialog.
            let autoChild =
                document.getElementById("team-autocomplete").firstElementChild;
            let el = angular.element(autoChild);
            (el.scope() as any).$mdAutocompleteCtrl.hidden = true;
            (el.scope() as any).$mdAutocompleteCtrl.blur();

            this.dialog
                .show({
                    component: "vc-team-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    size: "large-plus",
                    ariaLabel: "Create Team",
                    locals: {
                        selectedTeam: team,
                        hideUsers: this.hideUsers,
                    },
                })
                .then((team: Team) => {
                    this.teamChanged(team);
                });
        }

        setSearchText(objProp?: string): string {
            return objProp && objProp != "" ? objProp : "";
        }
    },
};

angular
    .module("team")
    .component(TeamAutocompleteComponent.selector, TeamAutocompleteComponent);
